/**
 * Pre-compiled localized messages for Avatar component
 *
 * Generated by scripts/generate-dictionaries.ts
 * DO NOT EDIT MANUALLY
 *
 * @see https://react-spectrum.adobe.com/react-aria/internationalization.html
 */

import {
  type LocalizedString,
  type LocalizedStrings,
} from "@internationalized/string";
import { normalizeMessages } from "../../utils/normalize-messages";

// Pre-compiled message functions
import avatarMessages_en from "./intl/en";
import avatarMessages_de from "./intl/de";
import avatarMessages_es from "./intl/es";
import avatarMessages_fr from "./intl/fr-FR";
import avatarMessages_pt from "./intl/pt-BR";

// Raw LocalizedStrings object for use with useLocalizedStringFormatter hook
export const avatarMessagesStrings: LocalizedStrings<string, LocalizedString> =
  {
    en: normalizeMessages(avatarMessages_en),
    de: normalizeMessages(avatarMessages_de),
    es: normalizeMessages(avatarMessages_es),
    "fr-FR": normalizeMessages(avatarMessages_fr),
    "pt-BR": normalizeMessages(avatarMessages_pt),
  } as LocalizedStrings<string, LocalizedString>;

/**
 * Available message keys for Avatar component
 */
export type AvatarMessageKey = "avatarLabel" | "avatarLabelGeneric";
